import React, { useState } from 'react';
import { Row, Col, Skeleton, Drawer } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { ReactComponent as Arrow } from '../../Icons/Arrow.svg';
import RightBlock from './RightBlock';
import cl from './catalog.module.css';

const Catalog = ({
    categories,
    isLoading,
    setIsShow,
    width,
    publications,
    initDataKey,
    isLoadingPubl,
}) => {
    const [active, setActive] = useState(1);
    const [isOpenedDrawer, setIsOpenedDrawer] = useState(false);
    return (
        <Row className={cl.card}>
            <Col className={cl.leftBlock} xs={24} sm={24} md={10} lg={8} xl={6}>
                {isLoading || categories.length <= 0
                    ? [1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                          <Skeleton.Button
                              key={item}
                              style={{ marginBottom: 20 }}
                              size="large"
                              shape="square"
                              active
                              block
                          />
                      ))
                    : categories?.map((item) => (
                          <Row
                              key={item.key}
                              className={`${cl.item} ${
                                  active === item.id ? cl.activeItem : ''
                              }`}
                              onMouseEnter={() => setActive(item.id)}
                              onClick={() => {
                                  setActive(item.id);

                                  if (width <= 768) {
                                      setIsOpenedDrawer(true);
                                  }
                              }}
                          >
                              <Row className={cl.content}>
                                  <Col>{item.name}</Col>
                                  {active === item.id && (
                                      <Arrow className={cl.arrow} />
                                  )}
                              </Row>
                          </Row>
                      ))}
                <hr style={{ borderColor: 'var(--primary-yellow)' }} />
                {isLoadingPubl || !publications
                    ? initDataKey.map((item) => (
                          <Skeleton.Button
                              key={item.key}
                              style={{ marginBottom: 20 }}
                              size="large"
                              shape="square"
                              active
                              block
                          />
                      ))
                    : initDataKey.map((item) => (
                          <Row
                              key={item.key}
                              className={`${cl.item} ${
                                  active === item.key ? cl.activeItem : ''
                              }`}
                              onMouseEnter={() => setActive(item.key)}
                              onClick={() => {
                                  setActive(item.key);

                                  if (width <= 768) {
                                      setIsOpenedDrawer(true);
                                  }
                              }}
                          >
                              <Row className={cl.content}>
                                  <Col>{item.title}</Col>
                                  {active === item.key && (
                                      <Arrow className={cl.arrow} />
                                  )}
                              </Row>
                          </Row>
                      ))}
            </Col>
            <Col
                className={cl.rightBlock}
                xs={0}
                sm={0}
                md={14}
                lg={16}
                xl={18}
            >
                <RightBlock
                    setIsShow={setIsShow}
                    category={categories.find((item) => item.id === active)}
                    publication={publications}
                    active={active}
                    isMobile={width <= 768}
                />
            </Col>

            <Drawer
                width="100%"
                style={{ background: 'var(--primary-dark)' }}
                title={
                    <h4 className={cl.drawerTitle}>
                        <Link
                            to={`/categories/${
                                categories.find((item) => item.id === active)
                                    ?.id
                            }`}
                            onClick={() => {
                                setIsShow(false);
                                setIsOpenedDrawer(false);
                            }}
                        >
                            {
                                categories.find((item) => item.id === active)
                                    ?.name
                            }
                        </Link>
                    </h4>
                }
                placement="right"
                closeIcon={
                    <LeftOutlined style={{ color: 'var(--primary-yellow)' }} />
                }
                open={isOpenedDrawer}
                onClose={() => setIsOpenedDrawer(false)}
            >
                <RightBlock
                    setIsShow={setIsShow}
                    category={categories.find((item) => item.id === active)}
                    isMobile={width <= 768}
                    publication={publications}
                    active={active}
                />
            </Drawer>
        </Row>
    );
};

export default Catalog;
